import React from 'react';
import LoaderComponent from 'react-loaders';
import './Loader.scss';

const Loader = () => {
    return(
        <LoaderComponent type="ball-spin-fade-loader" />
    );
};

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js